module.exports = __webpack_public_path__ + "static/media/border-center-h.3a0a2341.svg";